// extracted by mini-css-extract-plugin
module.exports = {"root":"ManageLink_root__3oh71"};